import React, { useEffect, useState } from 'react';

const Countdown = ({ timestamp, title, cstyle, cstyletitle, cstylecount, cstyletext, cstylebg }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tehranTime = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Tehran" }));
      const targetTime = new Date(timestamp).getTime();
      const difference = targetTime - tehranTime.getTime();

      if (difference <= 0) {
        setTimeLeft({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        setDisplay(false); // Hide the countdown
      } else {
        setTimeLeft({
          days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, '0'),
          hours: String(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
          minutes: String(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
          seconds: String(Math.floor((difference % (1000 * 60)) / 1000)).padStart(2, '0'),
        });
      }
    };

    calculateTimeLeft(); // Initial call
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [timestamp]);

  if (!display) return null;

  return (
    <div className={`flex flex-col items-center space-y-4 ${cstyle}`} dir="rtl">
      <h1 className={`font-bold ${cstyletitle}`}>{title}</h1>
      <div className="grid grid-flow-col gap-5 text-center auto-cols-max">
        <div className={`flex flex-col ${cstylebg} text-neutral-content ${cstyletext}`}>
          <span className={`countdown font-mono ${cstylecount}`}>
            <span style={{ "--value": timeLeft.days }}></span>
          </span>
          روز
        </div>
        <div className='grid grid-flow-col gap-2 md:gap-6' dir='ltr'>
            <div className={`flex flex-col ${cstylebg} text-neutral-content ${cstyletext}`}>
            <span className={`countdown font-mono ${cstylecount}`}>
                <span style={{ "--value": timeLeft.hours }}></span>
            </span>
            ساعت
            </div>
            <div className={`flex flex-col ${cstylebg} text-neutral-content ${cstyletext}`}>
            <span className={`countdown font-mono ${cstylecount}`}>
                <span style={{ "--value": timeLeft.minutes }}></span>
            </span>
            دقیقه
            </div>
            <div className={`flex flex-col ${cstylebg} text-neutral-content ${cstyletext}`}>
            <span className={`countdown font-mono ${cstylecount}`}>
                <span style={{ "--value": timeLeft.seconds }}></span>
            </span>
            ثانیه
            </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
